import Div from '../layout/Div'
import Icon from '../elements/Icon'
import { string } from 'prop-types'

const Alert = ({ message = '', cssClass = '', type = '', icon = '' }) => {
  if (!icon) {
    switch (type) {
      case 'is-success':
        icon = 'icon-done'
        break
      case 'is-info':
        icon = 'icon-info'
        break
      case 'is-warning':
        icon = 'icon-alert-triangle'
        break
      case 'is-help':
        icon = 'icon-help'
        break
      case 'is-unauthorized':
        icon = 'icon-blocked'
        break
      case 'is-danger':
        icon = 'icon-cancel-circle'
        break
    }
  }

  return (
    <Div cssClass={`notification ${type} ${cssClass}`}>
      <Icon icon={icon} /> <span>{message}</span>
    </Div>
  )
}

Alert.propTypes = {
  cssClass: string,
  icon: string,
  type: string,
  message: string
}

export default Alert
